import { MessageOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { IconBadge, IconBadgeContentColor } from 'components/ui/IconBadge';
import { TableCellController, TableFactoryRowModel } from 'stores/common';

type Props = {
  row?: TableFactoryRowModel;
  record: TableCellController;
};

const CommentsButton: React.FC<Props> = ({ row, record }: Props) => {
  const handleClick = React.useCallback(() => {
    row?.factoryTableStore.pubSub.publishCommentSelectEvent(record);
  }, [record, row?.factoryTableStore.pubSub]);

  const isActiveComment =
    row?.factoryTableStore?.activeCommentEntity?.params?.parentRowModel?.entity
      ?.rowId === record.params.parentRowModel?.entity?.rowId;

  if (!record.params.comments) {
    return null;
  }

  return (
    <IconBadge
      color={IconBadgeContentColor.info}
      isActive={isActiveComment}
      IconComponent={MessageOutlined}
      onClick={handleClick}
      count={record.params.comments.count}
    />
  );
};

export default observer(CommentsButton);
